<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
  <p>{{ text }}</p>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>{{ confirmationBtnText }}</button>
  <button mat-raised-button [mat-dialog-close]="false">{{ cancelBtnText }}</button>
</div>
